import React from 'react';
import QuizSubjectTopics from '../../../topics/QuizSubjectTopics';

function QuizBiologyTopics() {
  return (
   <>

   <QuizSubjectTopics name="quiz" link="quiz/biology" type="quiz" subject="biology" topic="atoz" subjectName="biology" />

   </>
  );
}

export default QuizBiologyTopics;